import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Content from "@/components/site/Content";
import Subscribe from "@/components/site/Subscribe";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <main className="min-h-screen bg-void">
      <Nav />
      <Hero />
      <Marquee
        items={["CLASSIFIED", "THINKAVARIUM", "DO NOT MISS AN EPISODE", "LEVEL 5 CLEARANCE"]}
        accent="text-reactor-red"
      />
      <Content />
      <Marquee
        items={["NEW SIGNAL WEEKLY", "STAY ON THE FREQUENCY", "TRANSMISSION INCOMING", "ENLIST NOW"]}
        accent="text-hazard-amber"
        speed="marquee-fast"
      />
      <About />
      <Subscribe />
      <Footer />
    </main>
  );
}
